import { Input } from 'antd';
import classNames from 'classnames';
// import '@style/components/textArea.scss';
import '../styles/components/textArea.scss';
import React from 'react';

const { TextArea: TA } = Input;
const TextArea = ({ className, children, ...restProps }) => {
  const classes = classNames('ma-text-area', className);
  return (
    <TA className={classes} {...restProps}>
      {children ? children : null}
    </TA>
  );
};

export default TextArea;
